<template>
  <div class="main-container">
    <ExamAttrSetting
      ref="attr"
      @created="onAttrCreated"
      @save="onAttrSave"
    ></ExamAttrSetting>
    <div class="exam-statistics">
      <div class="item answer" :class="{ logout: !isLogin }">
        <div class="num">{{ answer_num }}</div>
        <div class="label">作答次数</div>
        <div
          v-if="!isLogin"
          class="btn-login"
          @click="$LoginModal.login({ type: 'passwordLogin', store: $store })"
        >
          登录后查看
        </div>
      </div>
      <div class="item rate" :class="{ logout: !isLogin }">
        <el-progress
          v-if="isLogin"
          type="circle"
          :percentage="right_rate"
          color="#44D67A"
          :show-text="false"
          :stroke-width="10"
          :width="160"
        ></el-progress>
        <div class="rate-wrap">
          <div class="num-wrap">
            <span class="num">{{ right_rate_int }}</span>
            <span class="percent">
              {{ right_rate_decimal ? "." + right_rate_decimal : "" }}%
            </span>
          </div>
          <div class="label">正确率</div>
        </div>
        <div
          v-if="!isLogin"
          class="btn-login"
          @click="$LoginModal.login({ type: 'passwordLogin', store: $store })"
        >
          登录后查看
        </div>
      </div>
      <div class="item nav">
        <router-link
          :to="{ name: 'MemberEvaluation', query: { tab: 'test' } }"
          class="link"
        >
          <img class="img" src="@/assets/images/exam/record@2x.png" />
          <span class="text">练习记录</span>
        </router-link>
        <router-link
          :to="{ name: 'MemberEvaluation', query: { tab: 'mistake' } }"
          class="link"
        >
          <img class="img" src="@/assets/images/exam/error@2x.png" />
          <span class="text">错题集</span>
        </router-link>
        <router-link
          :to="{ name: 'MemberEvaluation', query: { tab: 'collect' } }"
          class="link"
        >
          <img class="img" src="@/assets/images/exam/collect@2x.png" />
          <span class="text">收藏夹</span>
        </router-link>
      </div>
    </div>
    <div class="nav-other">
      <a @click="beginSpecial" class="item">
        <div class="title">专项练习</div>
        <div class="circle">
          <img class="img" src="@/assets/images/exam/practice-special@2x.png" />
        </div>
        <div class="begin">开始练习</div>
      </a>
      <a @click="beginPackage" class="item">
        <div class="title">套卷练习</div>
        <div class="circle">
          <img class="img" src="@/assets/images/exam/practice-package@2x.png" />
        </div>
        <div class="begin">开始练习</div>
      </a>
      <a @click="beginRandom" class="item">
        <div class="title">随机练习</div>
        <div class="circle">
          <img class="img" src="@/assets/images/exam/practice-random@2x.png" />
        </div>
        <div class="begin">开始练习</div>
      </a>
      <a @click="beginFreedom" class="item">
        <div class="title">自由组卷</div>
        <div class="circle">
          <img class="img" src="@/assets/images/exam/practice-freedom@2x.png" />
        </div>
        <div class="begin">开始练习</div>
      </a>
    </div>
    <Message
      :visible.sync="showMessage"
      content="当前没有题目可以练习"
    ></Message>
    <LimitModal ref="limitModal" />
  </div>
</template>
<script>
import ExamAttrSetting from "./components/ExamAttrSetting.vue";

export default {
  name: "ExamIndex",
  components: { ExamAttrSetting },
  data() {
    return {
      visible: false,
      questionType: "专项练习",
      answer_num: 0,
      right_rate: 0,
      right_rate_int: "",
      right_rate_decimal: "",
      showMessage: false,
    };
  },
  computed: {
    isLogin() {
      return !!this.$store.state.token;
    },
  },
  // mounted() {
  //   this.$kefu()
  // },
  methods: {
    async getData() {
      let attr_val_id = this.$refs.attr.getAttrValId();
      if (this.$store.state.token) {
        let data = await this.$http.get("/api/app/special/first", {
          attr_val_id: attr_val_id,
        });
        this.answer_num = data.answer_num;
        let right_rate = data.right_rate.replace("%", "");
        this.right_rate = parseFloat(right_rate);
        this.right_rate_int = right_rate.split(".")[0];
        this.right_rate_decimal = right_rate.split(".")[1] || "";
      } else {
        this.answer_num = "****";
        this.right_rate_int = "**";
      }
    },
    async onAttrCreated() {
      await this.getData();
    },
    async beginSpecial() {
      await this.$refs.limitModal.checkAnswer(3, "专项练习");
      let treeData = await this.$http.get("/api/app/special/second", {
        attr_val_id: this.$refs.attr.getAttrValId(),
      });
      if (treeData.length == 0) {
        this.showMessage = true;
        return;
      }
      this.$router.push({ name: "ExamPoint" });
    },
    async beginPackage() {
      let data = await this.$http.get("/api/app/practice/package", {
        attr_val_id: this.$refs.attr.getAttrValId(),
      });
      if (data.total == 0) {
        this.showMessage = true;
        return;
      }
      this.$router.push({ name: "ExamPackage" });
    },
    //随机练习
    async beginRandom() {
      await this.$refs.limitModal.checkAnswer(1, "随机练习");
      //判断随机练习免费答题次数是否用完
      let data = await this.$http.post("/api/app/practice/report", {
        type: 1,
        attr_val_id:0
        //attr_val_id: this.$refs.attr.getAttrValId(),
      });
      if (data.length === 0) {
        this.showMessage = true;
        return;
      }
      this.$router.push({
        name: "ExamRandomDo",
        query: {
          id: data,
          examType: "随机练习",
        },
      });
    },
    // 自由组卷
    async beginFreedom() {
      await this.$refs.limitModal.checkAnswer(6, "自由组卷");
      // 判断是否有题可抽
      const info = await this.$http.get("/api/app/freedom/getQuestionInfo", {
        source: 3,
        attr_val_id: this.$refs.attr.getAttrValId(),
      });
      let quesCount = 0;
      for (const key in info.question_count_detail) {
        quesCount += info.question_count_detail[key];
      }
      if (!quesCount) {
        this.showMessage = true;
        return;
      }
      const data = await this.$http.get("/api/app/freedom/IsExistRemedied");
      if (data == 3) {
        // 第一次进入
        this.$router.push({
          name: "ExamFreedomRule",
          query: {
            attr_val_id: this.$refs.attr.getAttrValId(),
          },
        });
      } else if (data == 1) {
        // 记住选择
        this.$router.push({
          name: "ExamFreedomRule",
          query: {
            attr_val_id: this.$refs.attr.getAttrValId(),
            use_rule: 1,
          },
        });
      } else {
        // 不记住选择
        await this.$promiseConfirm("是否使用上次组卷规则", {
          callback: () => {
            this.$router.push({
              name: "ExamFreedomRule",
              query: {
                attr_val_id: this.$refs.attr.getAttrValId(),
              },
            });
          },
        });
        this.$router.push({
          name: "ExamFreedomRule",
          query: {
            attr_val_id: this.$refs.attr.getAttrValId(),
            use_rule: 1,
          },
        });
      }
    },
    async onAttrSave() {
      await this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  background-color: white;
  margin-bottom: 30px;
  margin-top: 20px;
  border-radius: 5px;
  padding: 0 40px;
  overflow: hidden;
  box-sizing: border-box;
}
.exam-statistics {
  background: white;
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 5px;
  padding: 36px 0;
  height: 160px;
  display: flex;
  align-items: center;

  .item {
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    position: relative;

    &:nth-child(1) {
      padding-right: 20px;
    }

    &:nth-child(2) {
      padding: 0 20px;
    }

    &:nth-child(3) {
      padding-left: 20px;
    }

    &:nth-child(1)::after,
    &:nth-child(2)::after {
      content: "";
      position: absolute;
      width: 1px;
      height: 156px;
      background: rgba(230, 230, 230, 1);
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .btn-login {
    width: 160px;
    height: 42px;
    background: $primary-color;
    border-radius: 21px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: white;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
    margin-top: 34px;
    display: block;

    &:hover {
      background: $primary-color-hover;
    }
  }

  .answer {
    width: 368px;
    flex-direction: column;
    align-items: center;
    .num {
      font-size: 46px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(52, 52, 52, 1);
      line-height: 35px;
      margin-bottom: 18px;
    }
    .label {
      font-size: 16px;
      color: rgba(52, 52, 52, 1);
      line-height: 1;
    }
    &.logout {
      .num {
        height: 21px;
        margin-bottom: 13px;
      }
    }
  }

  .rate {
    width: 386px;
    flex-direction: column;
    align-items: center;
    .rate-wrap {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
    .num-wrap {
      margin-bottom: 16px;
      display: flex;
      align-items: flex-end;
    }
    .num {
      font-size: 46px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(52, 52, 52, 1);
      line-height: 35px;
    }
    .percent {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(52, 52, 52, 1);
      line-height: 16px;
    }
    .label {
      font-size: 16px;
      color: rgba(52, 52, 52, 1);
      line-height: 1;
    }
    &.logout {
      .rate-wrap {
        position: static;
        transform: translate(0, 0);
        text-align: left;
      }
      .label {
        margin-left: 6px;
      }
      .num {
        height: 21px;
        margin-right: 8px;
      }
    }
  }

  .nav {
    flex-direction: column;
    flex-grow: 1;
    align-items: center;

    .link {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 136px;
      height: 38px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 5px;
      font-size: 15px;
      color: rgba(52, 52, 52, 1);

      &:nth-child(1),
      &:nth-child(2) {
        margin-bottom: 15px;
      }

      .img {
        width: 22px;
        height: 22px;
        margin-right: 9px;
      }

      .text {
        width: 60px;
        text-align: center;
      }
    }
  }
}
.nav-other {
  padding: 35px 0 30px 0;
  display: flex;
  justify-content: space-between;

  .item {
    width: 262px;
    height: 395px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;

    &:nth-child(1) {
      background: rgba(255, 247, 230, 1);

      .title {
        color: #e4ad2d;
      }

      .circle {
        background: rgba(255, 198, 64, 0.2);
      }

      .begin {
        background: rgba(245, 193, 50, 1);

        &:hover {
          background: #fad355;
        }
      }
    }

    &:nth-child(2) {
      background: #e8f4ff;

      .title {
        color: #3f9df2;
      }

      .circle {
        background: rgba(124, 190, 248, 0.2);
      }

      .begin {
        background: #3ba2ff;

        &:hover {
          background: #71b8fb;
        }
      }
    }

    &:nth-child(3) {
      background: rgba(233, 250, 242, 1);

      .title {
        color: #3dc29d;
      }

      .circle {
        background: rgba(109, 220, 180, 0.2);
      }

      .begin {
        background: #38d3a7;

        &:hover {
          background: #5ae0ba;
        }
      }
    }

    &:nth-child(4) {
      background: #fff2f2;

      .title {
        color: #ff4d4d;
      }

      .circle {
        background: rgba(255, 166, 166, 0.2);
      }

      .begin {
        background: #ff4d4d;

        &:hover {
          background: rgba(255, 77, 77, 0.8);
        }
      }
    }

    .img {
      width: 72px;
      height: 72px;
    }

    .title {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 600;
      line-height: 1;
      margin-bottom: 42px;
    }

    .circle {
      width: 148px;
      height: 148px;
      border-radius: 50%;
      margin-bottom: 41px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .begin {
      width: 197px;
      height: 42px;
      border-radius: 21px;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
      line-height: 42px;
      text-align: center;
    }
  }
}
</style>
